import React, { useEffect, useState } from 'react';
import { ActionModalBody, ActionModalFooter } from '../../../../../../components/Modal/templates/ActionModal';
import MicrosoftLogo from '../../../../../../../assets/img/MicrosoftLogo.svg';
import { Divider } from '../../../../../../components/Divider';
import { Button, ButtonVariant, CancelButton } from '../../../../../../components/Button';
import { IntegrationSettingsInput } from '../../../../../../../types/integration_settings';
import { useRequest } from '../../../../../../../requests/common/requestHook';
import { useToast } from '../../../../../../../providers/ToastProvider';
import { ToastType } from '../../../../../../components/Toast';
import { MicrosoftRequest } from '../../../../../../../requests/microsoft.request';

interface MicrosoftIntegrationConnectPaneProps {
  input: IntegrationSettingsInput;
  handleCancel: () => void;
}

export default function MicrosoftIntegrationConnectPane({ input, handleCancel }: MicrosoftIntegrationConnectPaneProps) {
  const { showToast } = useToast();

  const [opened, setOpened] = useState(false);
  const [startLink, { loading }] = useRequest<{}, string>(MicrosoftRequest.startLink);

  const openLinkFlow = async () => {
    const url = await startLink({ companyId: input.companyId });

    if (!url || typeof url !== 'string') {
      showToast({ type: ToastType.error, title: 'Failed to start Microsoft linking process.' });
      console.error('Invalid url returned from start link:', url);
      return;
    }

    window.open(url, '_blank');
    setOpened(true);
  };

  useEffect(() => {
    if (opened) return;
    openLinkFlow();
  }, []);

  return (
    <>
      <ActionModalBody>
        <div className='flex flex-col items-center gap-4 text-center'>
          <div className='h-[120px] w-[120px]'>
            <img src={MicrosoftLogo} alt='Microsoft' />
          </div>
          <p>{'Microsoft authorization opened in a new tab.'}</p>
          <p className='text-sm text-gray-500'>
            {'Complete authorization there, then refresh this page to view the linked integration.'}
          </p>
          <Button
            variant={ButtonVariant.secondary}
            text={'Open Microsoft again'}
            onClick={openLinkFlow}
            loading={loading}
          />
        </div>
      </ActionModalBody>
      <Divider />
      <ActionModalFooter>
        <div className='flex justify-end gap-2'>
          <CancelButton disabled={loading} onClick={handleCancel} />
        </div>
      </ActionModalFooter>
    </>
  );
}
